import {
  getManageZoneLayout,
  getOwnerLifecycleActions,
} from "../../realty/lib/propertyLifecycle";

function ManageActionButton({ action, disabled }) {
  const className = [
    "action-btn",
    action.successClass,
    action.dangerClass,
  ]
    .filter(Boolean)
    .join(" ");

  if (action.navigation) {
    return null;
  }

  return (
    <button
      type="button"
      className={className}
      data-bs-toggle="modal"
      data-bs-target={`#${action.modalId}`}
      disabled={disabled}
    >
      <i className={action.icon} aria-hidden="true" />
      {action.label}
    </button>
  );
}

function EditSectionManage({ property, isMutatingStatus, isDeleting }) {
  const anyInFlight = Boolean(isMutatingStatus || isDeleting);
  const { notice, statusActions, hasDelete, showModerationLock } =
    getManageZoneLayout(property);
  const deleteAction = getOwnerLifecycleActions(property, { isOwner: true }).find(
    (a) => a.id === "delete",
  );

  return (
    <section
      id="sec-manage"
      className="ap-pane ap-pane--danger"
      aria-labelledby="ap-pane-manage"
    >
      <header className="ap-pane__head">
        <h2 id="ap-pane-manage">
          <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
          Управління оголошенням
        </h2>
        <p>
          Зміна статусу, архівація та видалення застосовуються одразу — не
          вимагають натискання «Зберегти».
        </p>
      </header>

      {notice ? (
        <p className="ap-helper" role="note">
          {showModerationLock ? (
            <i className="fa-solid fa-shield-halved" aria-hidden="true" />
          ) : (
            <i className="fa-solid fa-circle-info" aria-hidden="true" />
          )}{" "}
          {notice}
        </p>
      ) : null}

      <div className="manage-grid">
        {statusActions.map((action) => (
          <ManageActionButton
            key={action.id}
            action={action}
            disabled={anyInFlight}
          />
        ))}
        {hasDelete && deleteAction ? (
          <button
            type="button"
            className="action-btn action-btn--danger"
            data-bs-toggle="modal"
            data-bs-target={`#${deleteAction.modalId}`}
            disabled={anyInFlight}
          >
            <i className={deleteAction.icon} aria-hidden="true" />
            {deleteAction.label}
          </button>
        ) : null}
      </div>
    </section>
  );
}

export default EditSectionManage;
